export const FETCH_INTYG_INFO_LIST_REQUEST = 'FETCH_INTYG_INFO_LIST_REQUEST'
export const FETCH_INTYG_INFO_LIST_SUCCESS = 'FETCH_INTYG_INFO_LIST_SUCCESS'
export const FETCH_INTYG_INFO_LIST_FAILURE = 'FETCH_INTYG_INFO_LIST_FAILURE'
